import { PredefinedMilisecondsTypeEnum } from '../../enums';
import { NullableString } from '../../util/types';

import { toPersistedUserEvent, UserSSEEvent } from './sse-event-types';

export const LAST_EVENT_ID_HEADER = 'last-event-id';

export const USER_EVENTS_LAST_EVENT_KEY = 'amsUserEventsLastEvent';

export const LAST_EVENT_TTL_MS = PredefinedMilisecondsTypeEnum.fiveMinutes - PredefinedMilisecondsTypeEnum.tenSeconds;

type StoredRecord = {
  event: UserSSEEvent;
  storedAt: number;
};

export const clearUserEventsLastEvent = (): void => {
  try {
    localStorage.removeItem(USER_EVENTS_LAST_EVENT_KEY);
  } catch (error) {
    console.error('[UserEvents] Could not clear the last event:', error);
  }
};

export const getUserEventsLastEvent = (): UserSSEEvent | null => {
  try {
    const stored = localStorage.getItem(USER_EVENTS_LAST_EVENT_KEY);

    if (!stored) {
      return null;
    }

    const { event, storedAt } = JSON.parse(stored) as StoredRecord;

    if (!event?.id || !storedAt || Date.now() - storedAt > LAST_EVENT_TTL_MS) {
      clearUserEventsLastEvent();
      return null;
    }

    return event;
  } catch (error) {
    console.error('[UserEvents] Could not read the last event:', error);
    clearUserEventsLastEvent();
    return null;
  }
};

export const getUserEventsLastEventId = (): NullableString => getUserEventsLastEvent()?.id;

/** Called for every event received, so the stored id is always the newest one seen. */
export const setUserEventsLastEvent = (event: UserSSEEvent): void => {
  if (!event?.id) {
    return; // Without an id it is useless for resuming
  }

  try {
    // Only the fields we declare are kept, same as the Redux state
    const record: StoredRecord = { event: toPersistedUserEvent(event), storedAt: Date.now() };

    localStorage.setItem(USER_EVENTS_LAST_EVENT_KEY, JSON.stringify(record));
  } catch (error) {
    console.error('[UserEvents] Could not store the last event:', error);
  }
};

